import { isServer } from './utils';

export const getReactHelmetPatching = (): JSX.Element | null => {
    if (isServer) {
        return null;
    }

    return (
        <script>
            {/* This needs to be at the end of helmet tags to sanitize scripts with async/defer - set to run in the client side only
            It prevents react-helmet reloading scripts that have async or defer attributes */}
            {`
                document
                    .querySelectorAll('head script[data-react-helmet][async]')
                    .forEach(function (script) {
                        script.setAttribute('async', true);
                    });
                document
                    .querySelectorAll('head script[data-react-helmet][defer]')
                    .forEach(function (script) {
                        script.setAttribute('defer', true);
                    });
            `}
        </script>
    );
};
